<template>
  <div class="form-group" :class="{'has-error': !isScoreValid}">
    <label for="access" class="control-label">Access</label>
    <select
      class="form-control"
      id="access"
      v-model="level"
      @change="adjustScoreBasedOnLevel">
      <option value="">(select access)</option>
      <option
        v-for="a of accessLevels"
        :key="a"
        :value="a"
        :selected="a === level">{{ a }}</option>
    </select>


    <label for="score" class="sr-only">Score</label>
    <div class="input-group input-group-sm">
      <input
        id="score"
        ref="score"
        type="number"
        class="form-control"
        step="0.1"
        :value="value"
        @input="$emit('input', parseFloat($event.target.value) || null)"
        @blur="manuallyEdit = false"
        :min="minScore"
        :max="maxScore"
        :disabled="!level || !manuallyEdit">
      <span class="input-group-btn">
        <button
          class="btn btn-default"
          :class="{active: manuallyEdit}"
          @click="toggleManualEdit"><i class="fa fa-pencil"/> Edit</button>
      </span>
    </div>
    <small class="help-block text-muted" v-if="level">Between {{ minScore }} and {{ maxScore }}</small>

  </div>
</template>

<script>
import { contentScoreCutoffs } from '@/util/goal_scores'

const accessTrial = 'trial'
const accessInvite = 'invite'
const accessPremium = 'premium'

const accessLevels = [accessTrial, accessInvite, accessPremium]
const bounds = {
  [accessPremium]: {
    min: contentScoreCutoffs.anchorMin,
    max: contentScoreCutoffs.anchorUnlockableMin - 0.001
  },
  [accessInvite]: {
    min: contentScoreCutoffs.anchorUnlockableMin,
    max: contentScoreCutoffs.anchorTrialMin - 0.001
  },
  [accessTrial]: {
    min: contentScoreCutoffs.anchorTrialMin,
    max: contentScoreCutoffs.anchorMax
  }
}

const accessLevelFromScore = score => {
  if (score >= bounds[accessPremium].min && score <= bounds[accessPremium].max) {
    return accessPremium
  }
  if (score >= bounds[accessInvite].min && score <= bounds[accessInvite].max) {
    return accessInvite
  }
  if (score >= bounds[accessTrial].min && score <= bounds[accessTrial].max) {
    return accessTrial
  }
  return ''
}

export default {
  name: 'EditScore',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      accessLevels,
      level: accessLevelFromScore(this.value),
      manuallyEdit: false
    }
  },
  computed: {
    minScore() {
      return (bounds[this.level] && bounds[this.level].min) || 0
    },
    maxScore() {
      return (bounds[this.level] && bounds[this.level].max) || 0
    },
    isScoreValid() {
      return (
        (this.level &&
          this.value >= bounds[this.level].min &&
          this.value <= bounds[this.level].max) ||
        !this.level
      )
    }
  },
  methods: {
    adjustScoreBasedOnLevel() {
      if (this.level) {
        // maintain existing decimal values when adjusting
        let adjAmount = this.minScore - Math.floor(this.value)

        // Default score for premium should be in the middle of the range (production team request)
        // use toFixed to eliminate long floating point artifacts (e.g. 4.499999). But toFixed returns string
        // so we reconvert using parseFloat
        if (this.level === accessPremium && !this.value) {
          adjAmount += parseFloat(((this.maxScore - this.minScore) / 2.0).toFixed(1))
        }
        this.$emit('input', this.value + adjAmount)
      }
    },
    toggleManualEdit() {
      this.manuallyEdit = !this.manuallyEdit
      if (this.manuallyEdit) {
        setTimeout(() => {
          this.$refs.score.focus()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.input-group {
  margin-top: 0.5em;
}
</style>
